import { useState } from "react";
import InputTextArea from "./InputTextArea";
import ButtonIconH from "./ButtonIconH";
import "../css/Diagnosis.css";

export default function Diagnosis(props) {
  const [input, setInput] = useState(props.value);

  return (
    <div className="external-window-bg">
      <div className="external-window diagnosis-window">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Diagnóstico</span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              props.onClose();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon" />
          </button>
        </div>
        <div className="container-panel diagnosis-container">
          <div className="external-window-body diagnosis-content">
            <InputTextArea
              maxLength={600}
              upperCase={false}
              type="type-full"
              size={0}
              input={input}
              onChange={(e) => {
                setInput(e);
              }}
            ></InputTextArea>
          </div>
          <div className="external-window-buttons">
            <ButtonIconH
              text="Guardar"
              onClick={() => {
                props.onSave(input);
                props.onClose();
              }}
            ></ButtonIconH>
          </div>
        </div>
      </div>
    </div>
  );
}
